import { z } from 'zod';
import { FeedCalendarSyncReportTypeSchema } from './listJob.js';
import { FeedPollingScheduleSchema } from './pollingSchedule.js';
/** Where on the SFTP server the feed's files land. */
export const FeedSftpParamsSchema = z
    .object({
    filepath: z.string().min(1),
    useNewServer: z.boolean().optional(),
})
    .strict();
/** The window a calendar sync pulls, in days either side of today. */
export const FeedCalendarSyncJobParamsSchema = z
    .object({
    firstRelativeDate: z.number(),
    lastRelativeDate: z.number(),
    reportType: FeedCalendarSyncReportTypeSchema,
    useWorkerReplicaDb: z.boolean().optional(),
})
    .strict();
export const FeedOutreachSyncJobParamsSchema = z
    .object({ outreachKind: z.string().min(1) })
    .strict();
const FeedJobConfigSchema = z.object({
    pollingSchedule: FeedPollingScheduleSchema,
    sftpParams: FeedSftpParamsSchema.optional(),
    disabledSFTPParams: FeedSftpParamsSchema.optional(),
});
/**
 * Only the two jobs that take parameters accept a `jobParams` key; for the rest it is an unknown
 * key and rejected. Null is a feed that runs no list job at all.
 */
export const FeedListJobConfigSchema = z.union([
    z.null(),
    FeedJobConfigSchema.extend({ jobParams: FeedCalendarSyncJobParamsSchema }).strict(),
    FeedJobConfigSchema.extend({ jobParams: FeedOutreachSyncJobParamsSchema }).strict(),
    FeedJobConfigSchema.strict(),
]);
//# sourceMappingURL=listJobConfig.js.map